'use strict';

angular.module('cimerFrontEndApp').directive('projectLogo',['ApiUrl', '$http', function(ApiUrl, $http) {
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/logoTemplate.html',
        scope: {
            surveyId: '=surveyId'
        },
        
        link: function (scope, element, attrs, ctrls) {
            var _apiUrl = ApiUrl.url('/Image/');
            scope.projects = [];
            if (scope.surveyId) {
                $http.get(_apiUrl + 'GetProjectLogo/' + scope.surveyId).then(function (response) {
                    scope.projects = response.data;
                });
            }
            else {
                $http.get(_apiUrl + 'GetProjectLogos').then(function (response) {
                    scope.projects = response.data;
                });
            }
        }
    };
}]);

